import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './AdCostChart.css';

const AdCostChart = () => {
  const { language } = useLanguage();
  const t = translations[language].adCostChart;
  const [ref, visible] = useScrollAnimation({ threshold: 0.2 });
  const [chartRef, chartVisible] = useScrollAnimation({ threshold: 0.15 });

  return (
    <section className="adcost-section">
      <div className="adcost-inner">
        <div
          ref={ref}
          className={`adcost-header scroll-fade-in ${visible ? 'is-visible' : ''}`}
        >
          <span className="section-label">{t.label}</span>
          <h2 className="adcost-title">{t.title}</h2>
          <p className="adcost-subtitle">{t.subtitle}</p>
        </div>

        <div
          ref={chartRef}
          className={`adcost-chart ${chartVisible ? 'adcost-chart-visible' : ''}`}
        >
          {t.bars.map((bar, i) => (
            <div
              key={i}
              className="adcost-row"
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              <div className="adcost-row-label">
                <span className="adcost-row-year">{bar.year}</span>
                <span className="adcost-row-ago">{bar.ago}</span>
              </div>

              <div className="adcost-row-track">
                <div
                  className="adcost-row-bar"
                  style={{ '--bar-width': bar.width }}
                >
                  <span className="adcost-row-value">{bar.cpc}</span>
                </div>
              </div>

              <div className="adcost-row-change">
                <span className={`adcost-row-badge ${i === 0 ? 'adcost-row-badge-base' : 'adcost-row-badge-up'}`}>
                  {bar.change}
                </span>
              </div>
            </div>
          ))}

          <div className="adcost-axis">
            <span>0</span>
            <span>25</span>
            <span>50</span>
            <span>75+</span>
          </div>

          <div className="adcost-alert">
            <span className="adcost-alert-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            </span>
            <span className="adcost-alert-text">{t.alert}</span>
          </div>
        </div>

        <p
          className={`adcost-source scroll-fade-in ${chartVisible ? 'is-visible' : ''}`}
        >
          {t.source}
        </p>
      </div>
    </section>
  );
};

export default AdCostChart;
